// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import * as GuildCommands from '@app/features/guild/commands/GuildCommands';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';
import * as FormUtils from '@app/lib/forms';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useState} from 'react';
export const GuildDeleteModal = observer(({guildId}: {guildId: string}) => {
	const {t, i18n} = useLingui();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const handleConfirm = async () => {
		setIsSubmitting(true);
		try {
			await GuildCommands.remove(guildId);
			ModalCommands.pop();
			ToastCommands.createToast({type: 'success', children: t`Community deleted`});
		} catch (error) {
			FormUtils.pushApiErrorModal(i18n, error);
		} finally {
			setIsSubmitting(false);
		}
	};
	return (
		<Modal.Root size="small" centered>
			<Modal.Header title={t`Delete Community`} />
			<Modal.Content>
				<Modal.ContentLayout>
					<Modal.Description>
						<Trans>
							Are you sure you want to delete this community? This action cannot be undone. All channels, messages, and
							settings will be permanently deleted.
						</Trans>
					</Modal.Description>
				</Modal.ContentLayout>
			</Modal.Content>
			<Modal.Footer>
				<Button onClick={ModalCommands.pop} variant="secondary">
					<Trans>I changed my mind</Trans>
				</Button>
				<Button onClick={handleConfirm} submitting={isSubmitting} variant="danger-primary">
					<Trans>Delete Community</Trans>
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
});
